import React from 'react';
import DayPickerInput from 'react-day-picker/DayPickerInput';
import { formatDate, parseDate } from 'react-day-picker/moment';
import moment from "moment/moment";

import DATE_FORMAT from "../constants/dateFormat";

import utils from '../../utils/utils';

class DateField extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      formData: props.formData,
    }
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      formData: nextProps.formData,
    });
  }

  onChange(date) {
    if (date) {
      const momentObj = moment(date);

      this.setState({
        formData: momentObj.format(DATE_FORMAT.dataTransfer),
      }, () => this.props.onChange(this.state.formData));
    } else {
      this.setState({
        formData: null,
      }, () => this.props.onChange(this.state.formData));
    }
  }

  render() {
    const inputProps = {
      className: 'form-control',
    };

    const momentObj = utils.getDateFromString(this.state.formData, DATE_FORMAT.dataTransfer);

    return (
      <div>
        <label className="control-label">{ this.props.schema.title }</label>
        <DayPickerInput value={ momentObj? momentObj.toDate(): '' }
                        formatDate={ formatDate }
                        parseDate={ parseDate }
                        format={ DATE_FORMAT.display }
                        placeholder="Select date..."
                        inputProps={ inputProps }
                        dayPickerProps={{
                          firstDayOfWeek: 1,
                        }}
                        component={props => <input className="form-control" {...props}/> } // TODO add clear button
                        onDayChange={ day => this.onChange(day) }
                        clickUnselectsDay={true}
        />
      </div>
    );
  }
}

export default DateField;